import { useState } from "react";
import { AlertTriangle, ChevronRight, Paperclip, Pencil } from "lucide-react";
import { ConfirmDelete } from "@/components/admin/AdminUi";
import { StatePill, rowStyle, fillStyle } from "@/lib/orderStatus";
import { WO_KEYS, WO_STATUS, eur } from "./woUtils";
import { NotifyBox } from "./WorkOrderDialog";
import { itDate } from "./utils";
import { ROW_GRID } from "./OrderCard";

const lbl = "xl:hidden font-mono text-[11px] uppercase text-slate-600 mr-1";

export function WorkOrderCard({ o, onEdit, onStatus, onDelete, onChanged, row, fx = "", done }) {
  const [open, setOpen] = useState(false);
  const next = WO_KEYS[WO_KEYS.indexOf(o.status) + 1];
  return (
    <div style={rowStyle(o.status)} className={`ord-row px-4 py-3.5 border-b-2 border-white text-base text-slate-900 space-y-2 ${row ? `${ROW_GRID} xl:space-y-0` : ""} ${done ? "opacity-60" : ""} ${fx}`} data-testid={`wo-card-${o.id}`}>
      <div className="flex flex-wrap items-center gap-1.5">
        <StatePill s={o.status} label={WO_STATUS[o.status].label} testid={`wo-status-${o.id}`} />
        {o.priority === "urgente" && <span className="text-xs px-2 py-1 rounded bg-red-700 text-white font-bold flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" /> URGENTE</span>}
      </div>
      <div className="font-mono text-sm text-slate-700"><span className={lbl}>N°</span>{o.number}</div>
      <div className="font-mono text-sm text-slate-700"><span className={lbl}>Consegna</span>{itDate(o.due_date)}</div>
      <div className="min-w-0">
        <div className="text-lg font-bold leading-tight break-words">{o.client.name}</div>
        {o.client.phone && <div className="text-sm text-slate-700">{o.client.phone}</div>}
      </div>
      <div className="min-w-0 space-y-1">
        <div className="font-semibold">{o.product_type} {o.qty > 1 && `× ${o.qty}`}</div>
        {o.description && <button type="button" onClick={() => setOpen(!open)} data-testid={`wo-desc-${o.id}`} title={open ? "Mostra meno" : "Mostra tutto"} className={`text-left text-sm text-slate-800 whitespace-pre-line w-full ${open ? "" : "line-clamp-2"}`}>{o.description}</button>}
        {o.attachments?.length > 0 && <span className="flex items-center gap-1 text-sm text-slate-700"><Paperclip className="w-3.5 h-3.5" /> {o.attachments.length} allegati</span>}
        <NotifyBox o={o} onDone={onChanged} />
      </div>
      <div className="text-sm"><span className={lbl}>Totale</span><b className="text-base">{eur(o.total)}</b>
        <div className="text-slate-700">Acconto {eur(o.deposit)}</div><div className="text-red-800 font-semibold">Saldo {eur(o.balance)}</div>
      </div>
      <div className="flex flex-wrap gap-2">
        {next && <button data-testid={`wo-next-${o.id}`} onClick={() => onStatus(o, next)} style={fillStyle(next)} className="press h-9 px-3 rounded-md text-sm font-bold flex items-center gap-1">{WO_STATUS[next].label} <ChevronRight className="w-4 h-4" /></button>}
        <button data-testid={`wo-edit-${o.id}`} onClick={() => onEdit(o)} className="press h-9 px-3 rounded-md border border-slate-400 bg-white text-sm font-semibold flex items-center gap-1"><Pencil className="w-4 h-4" /> Scheda</button>
        <ConfirmDelete small testId={`wo-delete-${o.id}`} title={`Eliminare l'ordine ${o.number}?`} text="Verrà tolto anche dal calendario." onConfirm={() => onDelete(o)} />
      </div>
    </div>
  );
}
